const MAX_BYTES = 5 * 1024 * 1024;
const PREFER_BYTES = 4 * 1024 * 1024;

function canvasToBlob(canvas, type, quality) {
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => (blob ? resolve(blob) : reject(new Error('toBlob returned null'))),
      type,
      quality
    );
  });
}

export async function captureScreen() {
  const { default: html2canvas } = await import('html2canvas');
  const target = document.documentElement;
  const scale = Math.min(window.devicePixelRatio || 1, 2);
  const canvas = await html2canvas(target, {
    scale,
    useCORS: true,
    allowTaint: false,
    foreignObjectRendering: false,
    backgroundColor: '#ffffff',
    logging: false,
    ignoreElements: (el) => Boolean(el.closest && el.closest('[data-issue-reporter]'))
  });

  let blob = await canvasToBlob(canvas, 'image/png');
  if (blob.size <= PREFER_BYTES) return blob;

  blob = await canvasToBlob(canvas, 'image/jpeg', 0.85);
  if (blob.size <= MAX_BYTES) return blob;

  const downscaled = document.createElement('canvas');
  downscaled.width = Math.round(canvas.width / 2);
  downscaled.height = Math.round(canvas.height / 2);
  downscaled.getContext('2d').drawImage(canvas, 0, 0, downscaled.width, downscaled.height);
  return canvasToBlob(downscaled, 'image/jpeg', 0.85);
}
